import { PiWarningCircle } from "react-icons/pi"

import { Dialog, DialogContent, DialogTitle } from "@/components/ui"
import { Button } from "@/components/ui"

interface WithdrawSuccessModalProps {
  open: boolean
  onClose: () => void
  onConfirm?: () => void
  amount: number | string
  expectedDate: string // Format: "dd/mm/yyyy"
  weekendNote?: string // Note khi ngày rơi vào cuối tuần
}

export function WithdrawSuccessModal({
  open,
  onClose,
  onConfirm,
  amount,
  expectedDate,
  weekendNote
}: WithdrawSuccessModalProps) {
  const formatAmount = (value: number | string): string => {
    const num = typeof value === "string" ? parseFloat(value) : value
    if (isNaN(num) || num <= 0) return "0"
    return num.toLocaleString("vi-VN")
  }

  const handleConfirm = () => {
    onConfirm?.()
    // Don't call onClose here, let onConfirm handle it
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className="max-w-[90vw] sm:max-w-md p-6 gap-0"
        showCloseButton={false}
        isDisabledPressBack
      >
        {/* Hidden title for accessibility */}
        <DialogTitle className="sr-only">Yêu cầu rút tiền thành công</DialogTitle>
        <div className="flex flex-col items-center gap-4">
          {/* Success Icon */}
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-green-100/80">
            <PiWarningCircle size={32} className="text-green-600" />
          </div>

          {/* Title */}
          <h2 className="text-lg font-bold text-black text-center">Yêu cầu rút tiền thành công</h2>

          {/* Body Text */}
          <p className="text-sm text-gray-600 text-center leading-relaxed">
            Số tiền <span className="font-semibold">{formatAmount(amount)} đ</span> đã được yêu cầu
            rút thành công. Dự kiến bạn sẽ nhận được vào ngày{" "}
            <span className="font-semibold">{expectedDate}</span>.
            {weekendNote && (
              <>
                <br />
                <span className="text-xs text-gray-500 italic">{weekendNote}</span>
              </>
            )}
          </p>

          {/* Buttons */}
          <div className="flex gap-3 w-full mt-2">
            <Button
              variant="outline"
              className="flex-1 h-10 rounded-lg border-gray-300 bg-white text-black hover:bg-gray-50"
              onClick={handleClose}
            >
              Đóng
            </Button>
            <Button
              className="flex-1 h-10 rounded-lg bg-green-600 text-white hover:bg-green-700"
              onClick={handleConfirm}
            >
              Xác nhận
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
